import {send} from "./http";
import {MfaChallenge, MfaMethod, TokenSet} from "./models";

// The refresh token travels only in the API's HttpOnly cookie, so every /token call includes credentials.
const withCookie = { credentials: 'include' as const };

// POST /token: signing in, renewing and signing out (tristar-corp-api TokensRouteHandler).
export const AuthApi = {
    // An MfaChallenge instead of tokens when the account has MFA on. turnstileToken is from the Turnstile widget (400
    // turnstile_failed: do the check again); 429 after too many tries for the account or from this address.
    login: (username: string, password: string, deviceId: string, turnstileToken: string) =>
        send<TokenSet | MfaChallenge>('POST', '/token', { grant_type: 'password', username, password, untrusted_device_id: deviceId, turnstile_token: turnstileToken }, undefined, withCookie),

    // The second step. 400: wrong or expired code; 401: the challenge expired; 429: too many attempts.
    verifyMfa: (mfaToken: string, method: MfaMethod, code: string, deviceId: string) =>
        send<TokenSet>('POST', '/token', { grant_type: 'mfa', mfa_token: mfaToken, method, code, untrusted_device_id: deviceId }, undefined, withCookie),

    // Emails a sign-in code (valid 10 minutes) to an account using email MFA.
    sendMfaEmailCode: (mfaToken: string) => send<void>('POST', '/token/mfa-email', { mfa_token: mfaToken }),

    // Uses the refresh cookie, and replaces it. 400 when there's no session.
    refresh: (deviceId: string) =>
        send<TokenSet>('POST', '/token', { grant_type: 'refresh_token', untrusted_device_id: deviceId }, undefined, withCookie),

    // Ends the cookie's session and clears the cookie.
    logout: () => send<void>('POST', '/token', { grant_type: 'remove' }, undefined, withCookie)
};
